var wrranty = document.querySelector(".js-warranty");
var hasPurchase = document.querySelector(".js-has-purchase");
var tagsEl = document.querySelector(".js-tags");
var purchaseMade = document.querySelector(".js-purchase-made");
var showHasPurchase = document.querySelector(".js-show-if-has-purchase");
var acceptsMarketing = document.getElementsByClassName("js-accepts-marketing");
var newsletter = document.getElementsByClassName("js-newsletter");
var registerForm = document.getElementById("create_customer");
var submitForm = document.querySelector(".js-submit-form");

window.addEventListener("load", function() {

  const slides = Array.from(
    document.querySelectorAll(".mySwiper2 .swiper-slide")
  );
  var swiper2 = new Swiper(".mySwiper2", {
    loop: false,
    slidesPerView: 1,
    preventClicks: false,
    centeredSlides: true,
    preventClicksPropagation: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: {
        freeMode: true,
        loop: slides.length > 4,
        el: ".mySwiper",
        slidesPerView: slides.length > 3 ? 4 : slides.length,
        spaceBetween: 10,
        watchSlidesProgress: true,
      },
    },
  });

  const tabs = Array.from(document.querySelectorAll(".js-tab"));
  const tabsBody = Array.from(document.querySelectorAll(".js-tab-body"));
  tabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      var id = e.currentTarget.dataset.id;
      if (e.currentTarget.classList.contains("active")) {
        const tabBody = document.querySelector(".js-tab-body.active");
        e.currentTarget.classList.remove("active");
        tabBody.classList.remove("active");
      } else {
        tabs.forEach((t) => {
          t.classList.remove("active");

          if (t.dataset.id === id) {
            t.classList.add("active");
          }
        });
        tabsBody.forEach((tb) => {
          tb.classList.remove("active");

          if (tb.dataset.id === id) {
            tb.classList.add("active");
          }
        });
      }
    });
  });
});

if (submitForm !== null) {
  submitForm.onclick = function (e) {
    e.preventDefault();
    let tags = "";
    var val = e.currentTarget.value;

    if (purchaseMade.value.length > 0) {
      tags = "PURCHASE_" + purchaseMade.value;
    }

    if (wrranty.value.length > 0) {
      tags += "," + "WARRANTY_" + wrranty.value;
    }

    if (acceptsMarketing[0].checked) {
      newsletter[0].value = "newsletter";
      tags += "," + "newsletter";
    } else {
      newsletter[0].value = "";
    }

    tagsEl.value = tags;
    registerForm.submit();
  };
}

if (hasPurchase !== null) {
  hasPurchase.onchange = function (e) {
    var val = e.currentTarget.checked;

    if (val) {
      showHasPurchase.style.display = "block";
    } else {
      showHasPurchase.style.display = "none";
    }
  };
}
